export default __webpack_public_path__ + "a5c5128c42c3a79aedbfa698a7a92803.svg";